module.exports = __webpack_public_path__ + "static/img/paygateway.7160f7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/paygateway.png
// module id = TYQW
// module chunks = 8